var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ObiText',_vm._g(_vm._b({staticClass:"obi-alert alert",class:_vm.componentClasses},'ObiText',_vm.attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }